/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Primary_GreetingInputs */

const en_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary Greeting`)
};

const es_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saludo principal`)
};

const fr_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message d'accueil principal`)
};

const de_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primäre Begrüßung`)
};

const ja_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の挨拶`)
};

const zh_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要问候语`)
};

const ar_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحية الأساسية`)
};

const id_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sapaan Utama`)
};

const it_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saluto Principale`)
};

const ru_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основное приветствие`)
};

const pt_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saudação Principal`)
};

const ko_primary_greeting = /** @type {(inputs: Primary_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 인사말`)
};

/**
* | output |
* | --- |
* | "Primary Greeting" |
*
* @param {Primary_GreetingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const primary_greeting = /** @type {((inputs?: Primary_GreetingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Primary_GreetingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_primary_greeting(inputs)
	if (locale === "es") return es_primary_greeting(inputs)
	if (locale === "fr") return fr_primary_greeting(inputs)
	if (locale === "de") return de_primary_greeting(inputs)
	if (locale === "ja") return ja_primary_greeting(inputs)
	if (locale === "zh") return zh_primary_greeting(inputs)
	if (locale === "ar") return ar_primary_greeting(inputs)
	if (locale === "id") return id_primary_greeting(inputs)
	if (locale === "it") return it_primary_greeting(inputs)
	if (locale === "ru") return ru_primary_greeting(inputs)
	if (locale === "pt") return pt_primary_greeting(inputs)
	return ko_primary_greeting(inputs)
});